import type { VirtualFile } from "@pdfking/pdfengine"

import type { FileObject } from "../types/FileObject"

import new_file_from_factory from "./new_file_from_factory"

export default ({
  file,
  path,
}: {
  file: VirtualFile
  path: string
}): FileObject =>
  new_file_from_factory({
    factory: async () => file,
    file_meta: file.file_meta,
    path,
  })
